import React from 'react';
import { H2 } from '@heading';
import Date from '@components/Date';
import styles from './List.module.scss';
import RawHTML from '@components/RawHTML';
import classNames from 'classnames';

export default function List({
  className,
  title,
  items,
  children,
  tag: Tag = 'section',
  ...restProps
}) {
  return (
    <Tag
      className={classNames(styles.wrapper, className)}
      {...restProps}
    >
      {title && <H2 className="h3">{title}</H2>}
      {(items?.length || children) && (
        <ul className={styles.list}>
          {items?.map((i, index) => (
            <Item
              key={index}
              {...i}
            />
          ))}
          {children}
        </ul>
      )}
    </Tag>
  );
}

const Item = React.memo(
  ({ text_md, subtext_md, text: _text, subtext: _subtext, date }) => {
    const text = text_md ?? _text;
    const subtext = subtext_md ?? _subtext;

    return !text ? null : (
      <li>
        <div className={styles.text}>
          <span className={styles.title}>
            <RawHTML>{text}</RawHTML>
          </span>
          {date && (
            <div className={styles.dateWrapper}>
              <Date
                value={date}
                className={styles.date}
              />
            </div>
          )}
        </div>
        {subtext && (
          <div className={styles.subtext}>
            <RawHTML>{subtext}</RawHTML>
          </div>
        )}
      </li>
    );
  }
);

export { List, Item };
